import { Form } from "antd";
import TextArea from "antd/lib/input/TextArea";
import GCReviewersDropdown from "components/gc-reveiewer-dropdown";
import { UserParticipationType } from "constants/index";
import { ProjectContext } from "context/ProjectProvider";
import { TFetureDetailUpdateAction } from "entity-app/models";
import { useContext, useEffect } from "react";

export default function DesignPackageGeneralInfo(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  disabled: boolean;
}) {
  const { featureInstanceData, actions, disabled } = props;
  const [form] = Form.useForm();

  const {
    columnHeaders: { designPackageHeaderMap }
  } = useContext(ProjectContext);

  useEffect(() => {
    const gcRepresentative =
      featureInstanceData?.feature_user_paticipants?.find(
        (participant: any) =>
          participant.user_participation_type_id ===
          UserParticipationType.GC_REPRESENTATIVE
      );

    form.setFieldsValue({
      description: featureInstanceData?.description,
      gc_representative: gcRepresentative?.user?.id
    });
  }, [featureInstanceData, form]);

  return (
    <Form layout="vertical" form={form}>
      <Form.Item name="description" label={designPackageHeaderMap?.description}>
        <TextArea
          disabled={disabled}
          rows={5}
          placeholder="Enter Description"
          onBlur={async (event: any) => {
            const oldValue = featureInstanceData?.description;
            if (oldValue === event?.target?.value?.trim()) return;
            await actions.updateFeatureInstanceFields({
              description: event.target.value?.trim()
            });
          }}
        />
      </Form.Item>
      <Form.Item
        label={designPackageHeaderMap?.gc_representative_id}
        name="gc_representative"
      >
        <GCReviewersDropdown
          disabled={disabled}
          onChange={async (value: any) => {
            await actions.updateFeatureUserParticipant({
              user_id: value,
              user_participation_type_id:
                UserParticipationType.GC_REPRESENTATIVE
            });
          }}
        />
      </Form.Item>
    </Form>
  );
}
